module.exports = __webpack_public_path__ + "static/media/React-icon.a5c4fdd3.svg";